import { render, staticRenderFns } from "./CtaTable.vue?vue&type=template&id=1ed50f7e&"
import script from "./CtaTable.vue?vue&type=script&lang=js&"
export * from "./CtaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports